import { DictionaryStore } from "@softline/core";

export const GroupSelectedFieldsStore = DictionaryStore.create<string[]>();
